export default "__VITE_ASSET__nTfqgs1H__"